module.exports = __webpack_public_path__ + "static/media/photo_correct_example.77bf5ebe.JPG";